import { useMemo, useRef, useState } from "react";
import { useQuery } from "react-query";

import { CCard, CCardBody } from "@coreui/react";

import { comboItemApi } from "src/1/apis/combo_item.api";
import { CTable } from "src/1/common/components/others";
import { CCheckbox } from "src/common/components/controls";
import { fireDelete, fireError, fireSuccess } from "src/utils/alert";

import { ComboItemForm, ComboItemToolbar } from "../../components";

const ComboItem = () => {
  //#region Data
  const drawerRef = useRef(null);

  const [params, setParams] = useState({ page: 1, size: 10 });
  const [selectedId, setSelectedId] = useState("");

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["danh-sach-combo-item", params],
    queryFn: () => comboItemApi.getPaginate(params),
    select: (response) => response?.data,
  });

  const listData = useMemo(() => data?.data ?? [], [data]);
  //#endregion

  //#region Event
  const onPageChange = (newPage) =>
    setParams((prev) => ({ ...prev, page: newPage }));

  const onLimitChange = (newLimit) =>
    setParams((prev) => ({ ...prev, size: newLimit, page: 1 }));

  const onAdd = () => drawerRef.current.open();

  const onEdit = () => drawerRef.current.open(selectedId);

  const onRemove = async () => {
    const allow = await fireDelete();
    if (allow) {
      try {
        await comboItemApi.remove(selectedId);
        refetch();
        fireSuccess();
      } catch (error) {
        fireError();
      }
    }
  };
  //#endregion

  //#region Render
  const headers = [
    {
      key: "selection",
      label: "",
      align: "center",
      width: 30,
      cellRender: (value, record) => (
        <CCheckbox
          value={selectedId === record?.id}
          onChange={() => {
            if (selectedId === record?.id) {
              setSelectedId("");
            } else {
              setSelectedId(record?.id);
            }
          }}
        />
      ),
    },
    {
      key: "code",
      label: "Mã Combo Item",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => drawerRef.current?.view(record.id)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "name",
      label: "Tên Combo Item",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => drawerRef.current?.view(record.id)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "cost",
      label: "Giá cost",
      align: "right",
      columnType: "number",
    },
    {
      key: "unit",
      label: "Đơn vị tính",
    },
    {
      key: "modified_date",
      label: "Ngày cập nhật gần nhất",
      columnType: "datetime",
    },
  ];
  return (
    <>
      <ComboItemToolbar
        canEdit={selectedId}
        canRemove={selectedId}
        canAdd
        onAdd={onAdd}
        onEdit={onEdit}
        onRemove={onRemove}
      />

      <CCard>
        <CCardBody className="pt-0 px-0">
          <div className="mt-3">
            <CTable
              loading={isFetching}
              headers={headers}
              data={listData}
              fontSizeBody={16}
              divider
              page={params?.page}
              pages={data?.metadata?.last_page}
              limit={params?.size}
              total={data?.metadata?.total}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
            />
          </div>
        </CCardBody>
      </CCard>

      <ComboItemForm refetch={refetch} ref={drawerRef} />
    </>
  );
  //#endregion
};
export default ComboItem;
